const Identity = require("../lib/identity.js");

const setupIdentity = () => {
  // Ensure we expose the identifier for other scripts/components
  const id = Identity.getCurrentUserIdentifier();

  // Expose read-only values
  Object.defineProperty(window, "__basa_identity", {
    value: {
      id,
      isAuthenticated: Identity.isAuthenticated(),
    },
    writable: false,
    configurable: true,
  });
};

document.addEventListener("turbolinks:load", setupIdentity);
